import React from 'react';
import SignupHeader from '../../SignupHeader/SignupHeader';
import OrderContainer from '../../../redux/containers/OrderContainer';
import SwitchedToOpenTermContainer from '../../../redux/containers/SwitchedToOpenTermContainer';
import SummaryContainer from '../../../redux/containers/SummaryContainer';

const Payment = () =>
  <main>
    <SignupHeader title="Payment" />
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h3 className="half-charcoal">Summary</h3>
        </div>
      </div>
    </div>
    <SummaryContainer />
    <SwitchedToOpenTermContainer />
    <OrderContainer />
  </main>
;

export default Payment;



/** WEBPACK FOOTER **
 ** ./src/components/payment/Payment/Payment.js
 **/